/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {
  channel_type_style,
  channel_bind_status_enum,
  status_enum,
  MemberSt,
  channel_type_enum,
} from 'hiya-common/src/reducers/commonTypes'
import {hAppEnum} from 'hiya-common/src/reducers/env'
import {noSelPayPaths} from './constant'

// 待确认（黄色）已确认（绿色）已拒绝（红色）已失效（灰色）
export enum InviteStatus {
  Confirm = 0,
  Confirmed = 1,
  Fail = 2,
  Reject = 3,
}

export enum InviteBDStatus {
  Confirm = -1,
  Confirmed = 1,
  Fail = -3, // 失效
  Reject = -2,
}

// 1 公会 2 主播 3 直播
export enum HomeTabs {
  Guild = 1,
  Anchor = 2,
  Live = 3,
}

// 1公会长 2主播 3普通人 4管理员
export enum RoleStatus {
  Guild = 1,
  Anchor = 2,
  Live = 3,
  Manager = 4,
}

// 1 直播信息 2 礼物信息 3 退款信息
export enum LiveDataPage {
  LiveInfo = 1,
  GiftInfo = 2,
  RefundInfo = 3,
}

// 1 全部 2 礼物收入 3 退款
export enum GiftInfoType {
  All = 1,
  GiftIncome = 2,
  Refund = 3,
}
// 薪资数据类别
export enum SalaryInfoType {
  All = 1,
  Settlement = 2,
  SettlementHigh = 21, // 进阶薪资
  Refund = 3,
  Award = 4,
}
// 主播管理页面tab 1 主播 2 管理员
export enum AnchorManageTabs {
  Anchor = 1,
  Manager = 2,
}

// 获取直播周期
export const getLiveCenterPeriod = createAsyncThunk(
  'AnchorCenter/getLiveCenterPeriod',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/settle_cfg', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 获取周期
export const getPeriod = createAsyncThunk(
  'AnchorCenter/getPeriod',
  async (p: any, store: any) => {
    const isSaada =
      store.getState().env.deviceinfo?.h_app?.toLowerCase() === hAppEnum.saada
    const url = `/live/${isSaada ? 'saada_settle' : 'union'}/get_operate_range`
    const resp = await http.post(url, {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// 获取收款窗口ids
export const get_receive_cashout_ids = createAsyncThunk(
  'AnchorCenter/get_receive_cashout_ids',
  async (p: {channel: channel_type_enum}, store: any) => {
    const isSaada =
      store.getState().env.deviceinfo?.h_app?.toLowerCase() === hAppEnum.saada
    const url = `/live/${
      isSaada ? 'saada_settle' : 'union'
    }/get_receive_cashout_ids`
    const resp = await http.post<
      HiyaRes<{
        list: {
          id: string // 收款id，唯一
          t_range: string // 时间
        }[]
      }>
    >(url, {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// 公会长代收主播薪资
// 代收数目记录 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105287653
export const getIncomeList = createAsyncThunk(
  'AnchorCenter/getIncomeList',
  async (p: any, store: any) => {
    const isSaada =
      store.getState().env.deviceinfo?.h_app?.toLowerCase() === hAppEnum.saada
    const url = `/live/${
      isSaada ? 'saada_settle' : 'union'
    }/get_union_owner_agent_list`
    const resp = await http.post(url, {
      ...store.getState().env.deviceinfo,
      ...p,
      kind: 1,
    })
    return resp.data
  }
)
// 公会长获取代收记录概览 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122789700
export const get_union_owner_agent_overview = createAsyncThunk(
  'AnchorCenter/get_union_owner_agent_overview',
  async (
    p: {
      receive_cash_out_id: string
    },
    store: any
  ) => {
    const isSaada =
      store.getState().env.deviceinfo?.h_app?.toLowerCase() === hAppEnum.saada
    const url = `/live/${
      isSaada ? 'saada_settle' : 'union'
    }/get_union_owner_agent_overview`
    const resp = await http.post(url, {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// 他人获取代收记录概览 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132047021
export const get_others_collection_overview = createAsyncThunk(
  'AnchorCenter/get_others_collection_overview',
  async (
    p: {
      receive_cash_out_id: string
    },
    store: any
  ) => {
    const isSaada =
      store.getState().env.deviceinfo?.h_app?.toLowerCase() === hAppEnum.saada
    const url = `/live/${
      isSaada ? 'saada_settle' : 'union'
    }/get_others_collection_overview`
    const resp = await http.post(url, {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)
// 直播信息Tab http://wiki.xunlei.cn/pages/viewpage.action?pageId=100420016
export const getLiveInfo = createAsyncThunk(
  'AnchorCenter/getLiveInfo',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/live_info_tab', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 直播信息礼物记录 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100420028
export const getLiveGiftInfo = createAsyncThunk(
  'AnchorCenter/getLiveGiftInfo',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/broadcaster_gift', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 直播信息退款记录 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100420032
export const getLiveRefundInfo = createAsyncThunk(
  'AnchorCenter/getLiveRefundInfo',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/broadcaster_refund', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 公会信息tab http://wiki.xunlei.cn/pages/viewpage.action?pageId=100419207
export const getUnionInfoTab = createAsyncThunk(
  'AnchorCenter/getUnionInfoTab',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/union_info_tab', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 获取主播信息 tab http://wiki.xunlei.cn/pages/viewpage.action?pageId=100420001
export const getAnchorInfoTab = createAsyncThunk(
  'AnchorCenter/getAnchorInfoTab',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/anchor_info_tab', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 主播中心 钻石和结算信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=164401352
export const getAnchorLiveInfo = createAsyncThunk(
  'AnchorCenter/getAnchorLiveInfo',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/account/get_anchor_live_and_settle_info',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data
  }
)

// 获取主播列表或管理员列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100419821
export const getAnchorManageList = createAsyncThunk(
  'AnchorCenter/getAnchorManageList',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/anchor_list_leader', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 删除主播
export const deleteUnionAnchor = createAsyncThunk(
  'UnionData/deleteUnionAnchor',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_delete_from_leader',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 取消管理员身份
export const cancelAdminAnchorByLeader = createAsyncThunk(
  'UnionData/cancelAdminAnchorByLeader',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/cancel_manager_from_leader', {
      ...store.getState().env.deviceinfo,
      leader_mid: store.getState().env.deviceinfo.h_m,
      ...p,
    })
    return resp.data
  }
)

// 设置管理员身份
export const setAdminAnchorByLeader = createAsyncThunk(
  'UnionData/setAdminAnchorByLeader',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/add_manager_from_leader', {
      ...store.getState().env.deviceinfo,
      leader_mid: store.getState().env.deviceinfo.h_m,
      ...p,
    })
    return resp.data
  }
)

// 邀请主播
export const inviteUnionAnchor = createAsyncThunk(
  'UnionData/inviteUnionAnchor',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_add_from_leader',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 管理员邀请主播
export const inviteUser = createAsyncThunk(
  'UnionData/inviteUser',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_add_from_manager',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

//   async (param = {}) => {
//   const res = await http.post('/live/union/anchor_add_from_manager', {
//     ...deviceinfo,
//     manager_mid: deviceinfo.h_m,
//     ...param,
//   })
//   setShowUser(false)
//   if (res.data?.data?.err_msg) {
//     onlyToast(res.data?.data?.err_msg)
//   }
// }

// 支付入口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92448321
export const getPayEnter = createAsyncThunk(
  'AnchorCenter/getPayEnter',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/pay_enter',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 收款渠道 ok true 弹  是否弹出确认默认支付弹窗 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122806606
export const check_default_pay_infom = createAsyncThunk(
  'AnchorCenter/check_default_pay_infom',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/check_default_pay_inform', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 确认弹窗 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122806606
export const set_default_pay_inform = createAsyncThunk(
  'AnchorCenter/set_default_pay_inform',
  async (p: {id: string}, store: any) => {
    const resp = await http.post(
      '/live/union/set_default_pay_inform',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取邀请主播中心记录
export const getInviteRecord = createAsyncThunk(
  'AnchorCenter/getInviteRecord',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/get_apply_by_union_id', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

// 非自主提现 公会长发放 is_cash_out: 0 共用一套接口
// 公会长前端查看结算数据 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=15314826
export const getUnionSettlementInfo = createAsyncThunk(
  'UnionSettlement/getUnionSettlementInfo',
  async (p: any, store: any) => {
    const {page_size: limit, page: offset, ...rest} = p
    const resp = await http.post('/live/union/get_live_settlement', {
      ...store.getState().env.deviceinfo,
      ...rest,
      limit: limit || 1,
      offset,
      is_cash_out: 0,
    })
    return {data: resp.data, page: p.page}
  }
)

export const getUnionSettlementCashoutList = createAsyncThunk(
  'UnionSettlement/getUnionSettlementCaseoutList',
  async (p: any, store: any) => {
    const {page_size: limit, page: offset, ...rest} = p
    const resp = await http.post('/live/union/get_live_settlement', {
      ...store.getState().env.deviceinfo,
      ...rest,
      limit: limit || 1,
      offset,
      is_cash_out: 1,
    })
    return {data: resp.data, page: p.page}
  }
)

// 公会薪资-获取数据
export const getLiveSettlementV2 = createAsyncThunk(
  'AnchorCenter/getLiveSettlementV2',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/get_live_settlement_v2', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getInvitationDetail = createAsyncThunk(
  'AnchorCenter/getInvitationDetail',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_union_detail',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=120401941
export const vip_level_info = createAsyncThunk(
  'AnchorCenter/live/vip/level_info',
  async (p, store: any) => {
    const resp = await http.post('/live/vip/level_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=90610956
export const confirmInvitation = createAsyncThunk(
  'AnchorCenter/confirmInvitation',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_confirm_invite',
      {
        ...store.getState().env.deviceinfo,
        ...p,
        is_from_h5: true,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 请求礼物
export const getGiftDetail = createAsyncThunk(
  'AnchorCenter/getGiftDetail',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/broadcaster_gift_detail', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 邀请主播 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100429529
export const inviteBDAnchor = createAsyncThunk(
  'AnchorCenter/inviteBDAnchor',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_common_invite_by_ids',
      {
        ...store.getState().env.deviceinfo,
        ...p,
        kind: 2,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 邀请主播确认 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100429524
export const confirmInviteBDAnchor = createAsyncThunk(
  'AnchorCenter/confirmInviteBDAnchor',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/common_confirm_invite',
      {
        ...store.getState().env.deviceinfo,
        ...p,
        kind: 2,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 薪资tab 子tab-所有  http://wiki.xunlei.cn/pages/viewpage.action?pageId=113903058
export const salary_tab = createAsyncThunk(
  'AnchorCenter/salary_tab',
  async (
    p: {
      id: number
      mid: number
      t_range: string
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/union/salary_tab',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 实时数据 总览  http://wiki.xunlei.cn/pages/viewpage.action?pageId=117025048
export const live_overview = createAsyncThunk(
  'AnchorCenter/live_overview',
  async (
    p: {
      t_range: string
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/union/live_overview',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface AnchorRefundItem {
  all: {
    cnt: number
    times: number
  }
  cur: {
    cnt: number
    times: number
  }
  next: {
    cnt: number
    times: number
  }
}

// 主播退款 总览  http://wiki.xunlei.cn/pages/viewpage.action?pageId=113904965
export const anchor_refund = createAsyncThunk(
  'AnchorCenter/anchor_refund',
  async (
    p: {
      id: number
      mid: number
      t_range: string
    },
    store: any
  ) => {
    const resp = await http.post<
      HiyaRes<{refund: AnchorRefundItem; repay: AnchorRefundItem}>
    >(
      '/live/union/anchor_refund',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 主播退款 某一笔订单的 详情  http://wiki.xunlei.cn/pages/viewpage.action?pageId=113904972
export const anchor_refund_detail = createAsyncThunk(
  'AnchorCenter/anchor_refund_detail',
  async (
    p: {
      id: number
      mid: number
      t_range: string
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/union/anchor_refund_detail',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 薪资总览  http://wiki.xunlei.cn/pages/viewpage.action?pageId=113909020
export const salary_overview = createAsyncThunk(
  'AnchorCenter/live/union/salary_overview',
  async (
    p: {
      t_range: string
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/union/salary_overview',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 公会退款总览  http://wiki.xunlei.cn/pages/viewpage.action?pageId=113909037
export const union_refund = createAsyncThunk(
  'AnchorCenter/live/union/union_refund',
  async (
    p: {
      t_range: string
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/union/union_refund',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取公会长信息  http://wiki.xunlei.cn/pages/viewpage.action?pageId=100418155
// 用于判断当前的是公会长还是主播
export const union_owner_info_by_mid = createAsyncThunk(
  'AnchorCenter/live/union/union_owner_info_by_mid',
  async (
    p: {
      h_m: number
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/union/union_owner_info_by_mid',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const unionUploadImg = createAsyncThunk(
  'AnchorCenter/unionUploadImg',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/misc/upload_img',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 主播等级首页数据  http://wiki.xunlei.cn/pages/viewpage.action?pageId=120390669
export const level_home_page = createAsyncThunk(
  'AnchorCenter/live/union/home_page',
  async (p, store: any) => {
    const resp = await http.post(
      '/live/union/home_page',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 主播等级获取奖励  http://wiki.xunlei.cn/pages/viewpage.action?pageId=120390676
export const level_get_rewards = createAsyncThunk(
  'AnchorCenter/live/union/get_rewards',
  async (p: {id: number}, store: any) => {
    const resp = await http.post(
      '/live/union/get_rewards',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 主播名人堂 http://wiki.xunlei.cn/pages/viewpage.action?pageId=120390688
export const hall_of_fame = createAsyncThunk(
  'AnchorCenter/live/union/rank',
  async (p, store: any) => {
    const resp = await http.post(
      '/live/union/rank',
      {
        ...store.getState().env.deviceinfo,
        offset: 0,
        limit: 0,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 根据mid获取支付绑定和认证信息列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92447647
export const pay_bind_list_by_mid = createAsyncThunk(
  'AnchorCenter_pay_bind_list_by_mid',
  async (
    arg: {
      channel_type?: any
      need_pass?: boolean
      version?: number
      need_trans_account?: boolean
    },
    store: any
  ) => {
    const {h_m: mid} = store.getState().env.deviceinfo
    const resp = await http.post('/live/union/pay_bind_list_by_mid', {
      ...store.getState().env.deviceinfo,
      mid,
      ...arg,
    })
    return resp.data.data
  }
)
export interface Pair {
  cur: string
  next: string
}

export interface Period {
  value: string
  text: string
}

export interface AnchorCenterde_list {
  list?: Array<{
    ct: string
    money: number
  }>
  page_size?: number
  offset?: number
  more?: boolean
}

// 收入列表
export interface LiveList {
  mid: number
  room_id: number
  income: number
  st: string
  et: string
  ct: string
  remain_time: number
  effect_time: number
  effect_times: number
  on_mic_income: number
  times: number
}

// 主播公会信息
export interface AnchorUnion {
  union_id: number
  name: string
  join_t: any
  // 目前所在的公会就没有退出时间
  quit_t?: any
  joined: Array<AnchorUnion>
  // 主播经历唯一表示id
  id: number
}

// 直播统计信息
export interface LiveInfo {
  diamond: number
  level: Pair
  exp: Pair // 经验
  day: Pair
  live_sec: number
  cur_anchor_income: number // 当级主播收入，记得取小数点后两位
  cur_free_anchor_income: number // 当级主播可自主提现薪资
  today_live_sec: Pair // 今天直播的时间 和需要达标的时间
}

export interface AnchorCenterLiveItem {
  // 自己的房间id
  room_id?: number
  anchor_union?: AnchorUnion
  live_info?: LiveInfo
  list?: Array<LiveList>
  page_size?: number
  offset?: number
  more?: boolean
}

export interface AnchorCenterUnionInfo {
  member?: any
  diamond?: number
  union?: {
    name: string
    union_id: number
    country: string
    ct: any
    anchor_cnt: number
    last_monday_female_ratio?: string
    this_monday_female_ratio?: string
    union_avatar?: string
    union_sign?: string
  }
  icon_list?: Array<{
    img: string
    name: string
    url: string
  }>
}

export interface AnchorCenterAnchorInfo {
  member?: any
  room?: {
    name: string
    room_id: number
    img: string
    level: Pair
    exp: Pair
    cnt: Pair
  }
  icon_list?: Array<{
    img: string
    name: string
    url: string
    sign_status: string
  }>
  diamond?: number
}

export interface AnchorLiveInfo {
  wallet_url?: string // 薪资钱包页面链接
  profile?: {
    member: any // 基础信息
    mid: number // 主播mid
    union_id: number // 主播所在公会id
    anchor_days: number // 成为主播天数
    anchor_level: number // 主播等级
  } // 主播信息
  live_data?: {
    period_st: string // 周期开始时间
    period_et: string // 周期结束时间
    diamond: number // 钻石数
    diamond_level: number // 钻石等级
    live_days: number // 直播天数
    required_days: number // 钻石等级所需天数
  } // 实时数据
  settle_data?: {
    period_st: string // 周期开始时间
    period_et: string // 周期结束时间
    free_anchor_income: number // 可提现薪资
    agent_anchor_income: number // 不可提现薪资
    other_income: number // 其他薪资
    settle_time: string // 结算时间
    is_new_settle: boolean // 是否有新结算数据
  } // 结算数据
}

export interface AnchorCenterManageInfo {
  from?: number
  list?: Array<{
    avatar: string
    show_id: string
    mid: number
    name: string
    income: number
    effective_day: number
    gender: number // 1女 2男 0保密
    is_manager: boolean // true 是
    age?: number
    selected?: boolean
  }>
  sort?: number
  page_size?: number
  offset?: number
  union_id?: number
  more?: boolean
}
export enum default_pay_status {
  在窗口期且不用弹窗 = 0,
  不在窗口期 = 1,
  在窗口期且需要弹窗确认默认支付 = 2,
}

interface SubInfoDT0 {
  name: string
  logo: string
  cnt: number
}

interface MenuList {
  title: string
  link: string
  menu_type: number
  sign_status: string
  status_color: string
  bind_status?: channel_bind_status_enum
  status?: status_enum
  style?: channel_type_style
  channel_type: channel_type_enum
  channel_account?: string
  sub_info?: SubInfoDT0
  owner?: MemberSt // 针对公会长代收需要公会长信息
  is_default?: boolean
  id?: string
  noSel?: boolean // true为不可选中的渠道
}
export interface AnchorCenterPayEnter {
  menu_list?: Array<MenuList>
  combined_menu_list?: Array<MenuList>
  menu_title?: string
  default_channel?: channel_type_enum
  check_default_pay_infom?: {
    id?: string
    default_channel?: channel_type_enum
    status: default_pay_status
  }
}

export interface AnchorCenterInviteInfo {
  list?: Array<{
    id: string
    mid: number
    show_id: string
    union_id: number
    status: number // 0:默认，1:申请已同意, 2:申请已过期
    inviter_mid: number
    inviter_show_id: string
    ct: number
    ut: number
  }>
  page_size?: number
  offset?: number
  more?: boolean
}

export interface AnchorCenterListInfo {
  diamond?: number
  list?: Array<any>
  page_size?: number
  offset?: number
  more?: boolean
  total_diamond?: number
}

export interface AnchorCenterSettlementInfo {
  union_settlement?: any
  union_diamond?: number
  anchor_settlement?: Array<any>
  page_size?: number
  offset?: number
  more?: boolean
}

export interface AnchorCenterGiftDetailList {
  on_mic_data?: AnchorCenterListInfo
  off_mic_data?: AnchorCenterListInfo
  im_data?: AnchorCenterListInfo
  post_data?: AnchorCenterListInfo
  other_data?: AnchorCenterListInfo
}
export const PageSize = 20
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=113909020
export interface salary_overview_type {
  overview: {
    total_salary: number
    union_salary: number
    on_anchor_salary: number
    on_anchor_cnt: number
    off_anchor_salary: number
    off_anchor_cnt: number
  }
  base: {
    on_anchor_salary: number
    on_anchor_cnt: number // 有基础薪资的在会主播 人
    on_commission: number // 公会长分成：
    off_anchor_salary: number // 本周期退会主播基础薪资：
    off_anchor_cnt: number // 有基础薪资的退会主播 人
    off_commission: number // 公会长分成：
  }
  reward: {
    on_anchor_salary: number // 本周期在会主播个人奖惩总和：
    on_anchor_cnt: number // 有个人奖惩薪资的在会主播：
    off_anchor_salary: number // 本周期退会主播个人奖惩总和：
    off_anchor_cnt: number // 有个人奖惩薪资的退会主播：
    total_reward: number // 公会奖励总和：
    total_punish: number // 公会惩罚总和：
  }
  refund: {
    on_anchor_salary: number // 本周期在会主播因前周期退款/回款被影响薪资：
    on_anchor_cnt: number // 本周期在会主播被退款影响：
    on_commission: number // 公会长因此被影响：
    off_anchor_salary: number // 本周期退会主播因前周期退款/回款被影响薪资：
    off_anchor_cnt: number // 本周期退会主播被退款影响：
    off_commission: number // 公会长因此被影响：
    pre_off_anchor_salary: number // 前周期退会主播因前周期退款/回款被影响薪资：
    pre_off_anchor_cnt: number // 前周期退会主播被退款影响：
    pre_off_commission: number // 公会长因此被影响：
  }
}
export interface live_overview_type {
  overview?: {
    diamond: number // 钻石
    incr: number // 今日增长
    anchor_cnt: number // 总主播数量
    off_anchor_cnt: number // 退会主播数量
  }
  distribution?: {
    level: number // 等级
    on_cnt: number // 在会数量
    off_cnt: number // 退会数量
    total: number // 总数量
  }[]
  selAnchor?: {
    mid: number
    id: number
  }
}
export interface hall_of_fame_type {
  member: MemberSt // 基础信息
  sort: number // 排名 1月份最靠前
  month: number // 月份
  color: string // 颜色
  score: number // 分数
}
interface PairFloat {
  cur: number
  incr: number
}

interface initType {
  live_tab_info?: AnchorCenterLiveItem
  period_list?: Array<Period>
  cur_period?: string
  de_list?: AnchorCenterde_list
  period_list_new?: Array<Period>
  cashout_ids_list?: Array<Period>
  union_info?: AnchorCenterUnionInfo
  anchor_info?: AnchorCenterAnchorInfo
  anchor_live_info?: AnchorLiveInfo
  anchor_info_list?: AnchorCenterManageInfo
  manage_info_list?: AnchorCenterManageInfo
  pay_enter?: AnchorCenterPayEnter
  invite_info_list?: AnchorCenterInviteInfo
  gift_info_list?: AnchorCenterListInfo
  refund_info_list?: AnchorCenterListInfo
  settlement_info_list?: AnchorCenterSettlementInfo
  gift_detail_list?: AnchorCenterGiftDetailList
  anchor_refund_detail?: any
  salary_overview?: salary_overview_type
  union_refund?: any
  live_overview?: live_overview_type
  level_home_page?: {
    count_down?: number
    member?: MemberSt
    banners?: {
      id: number // banner id
      cover: string // banner图片
      link: string // banner跳转链接
      score: number // banner权重
    }[]
    anchor_info?: {
      union_id: number // 公会id
      days: number // 成为主播天数 （如果主播中途退出公会，则数据清零）
      new: 0 | 1 // 是否新主播 0:否 1:是
      level: number // 主播等级  0New 1Rising 2Super 3Silvier 4Golden 5Legend
      score: number // 当前分数
      stage_job_score: number // 等级任务进度
    }
    level_rewards?: {
      level: number // 主播等级 0New 1Rising 2Super 3Silvier 4Golden 5Legend
      min_score: number // 最低等级分数
      score: number // 主播等级分数
      rewards: {
        icon: string // icon
        desc: string // 描述
      }[]
    }[]
    stage_jobs?: {
      id: number // 阶段id
      need: number // 阶段需要值
      icon: string // 阶段任务ICON
      status: number // 0:未达到;1:目标达到;2:奖励已领取
      name: string // 阶段任务名称
    }[]
    jobs?: {
      id: number // 阶段id
      name: string
      status: number // 0:未达到;1:目标达到;2:奖励已领取
      jump_url: string // 跳转链接
      reward_cnt: number // 奖励钥匙数量
    }[]
    hall_of_fame?: hall_of_fame_type[]
  }
  union_owner_agent_overview?: {
    income?: PairFloat
    anchor?: PairFloat
  }
  others_collection_overview?: {
    income?: PairFloat
  }
  vip_level_info?: {
    has_limit: boolean
    limit_level: number
    vip_level: number
  }
  // 获取公会长信息
  union_owner_info?: {
    member: MemberSt
    union: {
      mid: number
      create_time: string
      is_cash_out: number
      union_id: number
      union_name: string
      union_mid: number
      union_area_code: number
    }
  }
  pay_bind_list?: {
    channel_type: channel_type_enum
    channel_account: string
    default_channel_type: channel_type_enum
  }[]
}
const initialState: initType = {}
const initData: initType = {
  live_tab_info: {},
  period_list: [],
  de_list: {},
  period_list_new: [],
  union_info: {},
  anchor_info: {},
  anchor_live_info: {},
  anchor_info_list: {},
  manage_info_list: {},
  pay_enter: {},
  invite_info_list: {},
  gift_info_list: {},
  refund_info_list: {},
  settlement_info_list: {},
  gift_detail_list: {
    on_mic_data: {},
    off_mic_data: {},
    im_data: {},
    post_data: {},
    other_data: {},
  },
  level_home_page: {},
  union_owner_agent_overview: {},
  others_collection_overview: {},
}

export const AnchorCenterSystemSlice = createSlice({
  name: 'AnchorCenterSystem',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    selLiveViewAnchor: (state, action) => {
      Object.assign(state, {
        live_overview: {
          ...state.live_overview,
          selAnchor: {...action.payload},
        },
      })
    },
    clearUnionAnchorList: (state) => {
      Object.assign(state.anchor_info_list, {
        list: [],
        offset: 0,
      })
    },
    setUnionAnchorList: (state, action) => {
      const {list} = action.payload
      Object.assign(state.anchor_info_list, {
        list,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLiveInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      if (data?.offset > 20) {
        Object.assign(state.live_tab_info, {
          ...data,
          list: [...state.live_tab_info.list, ...data?.list],
        })
      } else {
        Object.assign(state.live_tab_info, data)
      }
    })
    builder.addCase(getLiveGiftInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      if (data?.offset > 20) {
        Object.assign(state.gift_info_list, {
          ...data,
          list: [...state.gift_info_list.list, ...data?.list],
        })
      } else {
        Object.assign(state.gift_info_list, data)
      }
    })
    builder.addCase(getLiveRefundInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      if (data?.offset > 20) {
        Object.assign(state.refund_info_list, {
          ...data,
          list: [...state.refund_info_list.list, ...data?.list],
        })
      } else {
        Object.assign(state.refund_info_list, data)
      }
    })
    builder.addCase(getLiveCenterPeriod.fulfilled, (state, action) => {
      const {
        data: {list},
      } = action.payload
      Object.assign(
        state.period_list,
        list.map((item) => {
          return {text: item, value: item}
        })
      )
    })
    builder.addCase(getUnionInfoTab.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state.union_info, data)
    })
    builder.addCase(getAnchorInfoTab.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state.anchor_info, data)
    })
    builder.addCase(getAnchorLiveInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state.anchor_live_info, data)
    })
    builder.addCase(getAnchorManageList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      if (data?.from === 0) {
        // 主播列表
        if (data?.offset > 20) {
          Object.assign(state.anchor_info_list, {
            ...data,
            list: [...state.anchor_info_list.list, ...data?.list],
          })
        } else {
          Object.assign(state.anchor_info_list, data)
        }
      }
      if (data?.from === 1) {
        // 管理员列表
        if (data?.offset > 20) {
          Object.assign(state.manage_info_list, {
            ...data,
            list: [...state.manage_info_list.list, ...data?.list],
          })
        } else {
          Object.assign(state.manage_info_list, data)
        }
      }
    })
    builder.addCase(getInviteRecord.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state.invite_info_list, data)
    })
    builder.addCase(getLiveSettlementV2.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      if (data?.offset > 20) {
        Object.assign(state.settlement_info_list, {
          ...data,
          list: state.settlement_info_list?.anchor_settlement
            ? [
                ...state.settlement_info_list?.anchor_settlement,
                ...data?.anchor_settlement,
              ]
            : [...data?.anchor_settlement],
        })
      } else {
        Object.assign(state.settlement_info_list, data)
      }
    })
    builder.addCase(getGiftDetail.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {kind, offset} = data || {}
      switch (kind) {
        case 1:
          if (offset > 3) {
            Object.assign(state.gift_detail_list?.on_mic_data, {
              ...data,
              list: [
                ...state.gift_detail_list?.on_mic_data?.list,
                ...data?.list,
              ],
            })
          } else {
            Object.assign(state.gift_detail_list?.on_mic_data, data)
          }
          break
        case 2:
          if (offset > 3) {
            Object.assign(state.gift_detail_list?.off_mic_data, {
              ...data,
              list: [
                ...state.gift_detail_list?.off_mic_data?.list,
                ...data?.list,
              ],
            })
          } else {
            Object.assign(state.gift_detail_list?.off_mic_data, data)
          }
          break
        case 3:
          if (offset > 3) {
            Object.assign(state.gift_detail_list?.im_data, {
              ...data,
              list: [...state.gift_detail_list?.im_data?.list, ...data?.list],
            })
          } else {
            Object.assign(state.gift_detail_list?.im_data, data)
          }
          break
        case 4:
          if (offset > 3) {
            Object.assign(state.gift_detail_list?.post_data, {
              ...data,
              list: [...state.gift_detail_list?.post_data?.list, ...data?.list],
            })
          } else {
            Object.assign(state.gift_detail_list?.post_data, data)
          }
          break
        case 5:
          if (offset > 3) {
            Object.assign(state.gift_detail_list?.other_data, {
              ...data,
              list: [
                ...state.gift_detail_list?.other_data?.list,
                ...data?.list,
              ],
            })
          } else {
            Object.assign(state.gift_detail_list?.other_data, data)
          }
          break
        default:
          break
      }
    })
    builder.addCase(getPeriod.fulfilled, (state, action) => {
      const {
        data: {list},
      } = action.payload
      Object.assign(
        state.period_list_new,
        list?.map((item) => {
          return {text: item, value: item}
        })
      )
    })
    builder.addCase(get_receive_cashout_ids.fulfilled, (state, action) => {
      Object.assign(state, {
        cashout_ids_list: (action.payload?.list || [])?.map((item) => {
          return {text: item.t_range, value: item.id}
        }),
      })
    })

    builder.addCase(getIncomeList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      if (data?.offset > 10) {
        Object.assign(state.de_list, {
          ...data,
          list: [...state.de_list.list, ...data?.list],
        })
      } else {
        Object.assign(state.de_list, data)
      }
    })
    builder.addCase(anchor_refund_detail.fulfilled, (state, action) => {
      Object.assign(state, {
        anchor_refund_detail: action.payload.overview || {},
      })
    })
    builder.addCase(salary_overview.fulfilled, (state, action) => {
      Object.assign(state, {
        salary_overview: action.payload || {},
      })
    })
    builder.addCase(union_refund.fulfilled, (state, action) => {
      Object.assign(state, {
        union_refund: action.payload || {},
      })
    })
    builder.addCase(live_overview.fulfilled, (state, action) => {
      Object.assign(state, {
        live_overview: {
          ...action.payload,
        },
      })
    })

    // 主播等级中心
    builder.addCase(level_home_page.fulfilled, (state, action) => {
      Object.assign(state.level_home_page, action.payload || {})
    })
    builder.addCase(hall_of_fame.fulfilled, (state, action) => {
      Object.assign(state.level_home_page, {
        hall_of_fame: action.payload?.hall_of_fame || [],
        count_down: action.payload?.count_down || 0,
      })
    })
    builder.addCase(
      get_union_owner_agent_overview.fulfilled,
      (state, action) => {
        Object.assign(state.union_owner_agent_overview, action.payload || {})
      }
    )
    builder.addCase(
      get_others_collection_overview.fulfilled,
      (state, action) => {
        Object.assign(state.others_collection_overview, action.payload || {})
      }
    )
    builder.addCase(vip_level_info.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {vip_level_info: data})
    })
    builder.addCase(getPayEnter.fulfilled, (state, action) => {
      const {union_owner_info, pay_bind_list} = state
      const temp = []
      let default_channel = 0
      // const
      pay_bind_list?.forEach((pay) => {
        // 将绑定的默认渠道放到第一个
        if (pay.default_channel_type === pay.channel_type) {
          temp.unshift(pay)
          default_channel = pay.default_channel_type
        } else {
          temp.push(pay)
        }
      })

      const {
        data: {menu_list = [], menu_title, combined_menu_list},
      } = action.payload
      // 已经绑定的渠道
      const binded_list = temp.map((bI) => ({
        id: bI.id,
        channel_account: bI.channel_account,
        ...menu_list?.find((m) => m.channel_type === bI.channel_type),
      }))
      // 可选渠道的顺序：通过的渠道，不能被选择的渠道，未审核的渠道
      Object.assign(state, {
        pay_enter: {
          ...(state?.pay_enter || {}),
          menu_list: [
            ...binded_list.filter(
              (bI) => !noSelPayPaths.some((noSel) => noSel === bI.channel_type)
            ),
            ...binded_list
              .filter((bI) =>
                noSelPayPaths.some((noSel) => noSel === bI.channel_type)
              )
              ?.map((item) => ({...item, noSel: true})),
            ...menu_list.filter(
              (m) =>
                !binded_list.some((bI) => bI.channel_type === m.channel_type)
            ),
          ]?.map((menu) => ({
            ...menu,
            ...(menu.channel_type === channel_type_enum.公会长代收
              ? {
                  owner: union_owner_info?.member,
                }
              : {}),
          })),
          menu_title,
          default_channel,
          combined_menu_list,
        },
      })
    })
    builder.addCase(check_default_pay_infom.fulfilled, (state, action) => {
      Object.assign(state, {
        pay_enter: {
          ...(state?.pay_enter || {}),
          check_default_pay_infom: action.payload,
        },
      })
    })
    builder.addCase(union_owner_info_by_mid.fulfilled, (state, action) => {
      Object.assign(state, {union_owner_info: action.payload})
    })
    builder.addCase(pay_bind_list_by_mid.fulfilled, (state, action) => {
      Object.assign(state, {
        pay_bind_list: action.payload?.list || [],
      })
    })
  },
})

export const AnchorCenterAction = AnchorCenterSystemSlice.actions
export default AnchorCenterSystemSlice.reducer
